import { RootState } from '../../../../rootReducer';

export const withdrawalSelector = (state: RootState) => state.handbookModuleReducer.WithdrawalReducer;
